import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, apiError } from "../lib/api";
import { TID } from "../lib/testIds";

const inputCls =
  "w-full border border-ink/15 bg-paper px-4 py-3 text-sm text-ink placeholder-ink/40 transition-colors focus:border-crimson/60 focus:outline-none";

export const QuestionForm = () => {
  const [form, setForm] = useState({ name: "", email: "", question: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !/^\S+@\S+\.\S+$/.test(form.email) || !form.question.trim()) {
      toast.error("Please add your name, a valid email and your question.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/enquiries", { ...form, phone: "", package_id: "faq", package_name: "Custom question", message: form.question });
      toast.success("Question sent — we'll reply by email within a working day.");
      setForm({ name: "", email: "", question: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form data-testid={TID.pricing.questionForm} onSubmit={submit} className="mt-6 space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <input data-testid="faq-input-name" className={inputCls} placeholder="Your name *" value={form.name} onChange={set("name")} />
        <input data-testid="faq-input-email" className={inputCls} type="email" placeholder="Email *" value={form.email} onChange={set("email")} />
      </div>
      <textarea
        data-testid="faq-input-question"
        rows={3}
        className={inputCls}
        placeholder="Type your question about packages, pricing or maintenance *"
        value={form.question}
        onChange={set("question")}
      />
      <button
        data-testid="faq-submit-question"
        disabled={busy}
        className="inline-flex items-center gap-2 bg-crimson px-6 py-3 font-display text-sm font-bold text-white transition-colors hover:bg-crimsondark disabled:opacity-50"
      >
        <Send className="h-4 w-4" /> {busy ? "Sending…" : "Send question"}
      </button>
      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-ink/50">Comes straight to our inbox — we reply by email.</p>
    </form>
  );
};
